import React from "react";
import { NavLink } from "react-router-dom";

export const MobileNavBarBrand = ({ handleClick }) => {
  return (
    <div onClick={handleClick} className="mobile-nav-bar__brand">
      <NavLink to="/">
        <img
          className="mobile-nav-bar__logo"
          src="https://dopl-public-files.s3.us-west-2.amazonaws.com/dopl-logo-compliant-square.png"
          alt="Dopl Technologies logo"
          height="24"
        />
      </NavLink>
    </div>
  );
};
